/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        bubbleBorderColor: '#b2b9bf',
        bubbleBorderRadius: 45,
        bubbleBorderWidth: 1
      }
    },
    {
      if: { focus: true },
      tokens: {
        bubbleBorderColor: '#676e73',
        bubbleBorderRadius: 45,
        bubbleBorderWidth: 1
      }
    },
    {
      if: { pressed: true },
      tokens: {
        bubbleBorderColor: '#e3e6e8',
        bubbleBorderRadius: 45,
        bubbleBorderWidth: 1
      }
    },
    {
      if: { selected: true },
      tokens: {
        bubbleBorderColor: '#4b286d',
        bubbleBorderRadius: 45,
        bubbleBorderWidth: 1
      }
    }
  ],
  tokens: {
    borderColor: '#e3e6e8',
    borderRadius: 45,
    borderWidth: 1,
    bubbleBorderColor: 'rgba(0, 0, 0, 0)',
    bubbleBorderRadius: 0,
    bubbleBorderWidth: 0,
    innerBubbleBorderRadius: 45,
    innerBubbleHeight: 40,
    innerBubbleWidth: 40,
    outerBubbleContentAlignItems: 'center',
    outerBubbleHeight: 48,
    outerBubbleJustifyContent: 'center',
    outerBubbleWidth: 48,
    shadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: true,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    space: 2
  }
}
export default theme
